import React, { useCallback, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import SriyanshCardHeader from "../../components/CardHeader";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CircularProgress from "@mui/material/CircularProgress";
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import dayjs from "dayjs";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import apiClient from "../../BaseUrl/apiClient.js";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
function SuitabilityEntry() {
  const navigate = useNavigate();
  const [suitabilityDone,setSuitabilityDone]=useState(null);
 const [pageLoader, setPageLoader] = useState(false);
  const [poNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poQuantity, setpoQuantity] = useState(0);
  const [poDate, setpoDate] = useState(null);
  const [ConsigneeName, setConsigneeName] = useState("");
  const { state } = useLocation();
  //const [indentId, setindentId] = useState(state.indent_id);
  let poNumberFromList = state.exppo ?? "";
  //const [poNumberFromList, setpoNumberFromList] = useState();
  let gatepassNumberFromList = state.expgatepass ?? "";
  // const [gatepassNumberFromList, setgatepassNumberFromList] = useState(
  //   state.expgatepass??''
  // );
  const [buttonLoading, setButtonLoading] = useState(false);
  const [receivedQuantity, setreceivedQuantity] = useState(0);
  const [receivedvalue, setreceivedvalue] = useState(0);

  const [suitableQty, setSuitableQuantity] = useState(0);

  const [reason, setReason] = useState("");

  const [item_receivedDate, setitemreceivedDate] = useState("");

  const [suitabilityDate, setsuitabilityDate] = useState(null);
  const [memoDate, setmemoDate] = useState(null);

  const [selectedOption, setSelectedOption] = useState("");

  // const [dateerror, setDateError] = useState("");

  // const [memodateerror, setmemoDateError] = useState("");

  const today = dayjs();
  //const [minCalDate, setMinCalDate] = useState(dayjs());
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [balanceqty, setBalanceqty] = useState(0);
  const [showRemark, setShowRemark] = useState(true);

  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasons, setRejectReasons] = useState([]);

  const handleClose = () => {
    navigate("../suitabilitylist", { replace: true });
  };

  const handleQuantityChange = (value) => {
    setSuitableQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);
    if (selvalue === "0") {
      setShowRemark(true);
      setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const fetchSuitabaleReason = async () => {
    try {
      const response = await apiClient.post("/unsuitabilityReasonList", {
        /* request payload if needed */
      });
      setRejectReasons(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchSuitabaleReason();
  }, []);

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    if (rejectReasons.length > 0) {
      setRejectReason(rejectReasons[0].id);
    }
  }, [rejectReasons]);

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const [unsuitablePOList, setunsuitablePOList] = useState([]);

  // const getUnsutablePOdata = useCallback(async () => {
  //     if (!poNumber || poNumber.trim() === "") return;
  //     if (!gatepassNumberFromList || gatepassNumberFromList.trim() === "") return;
  //   setButtonLoading(true);
  //   try {
  //     const response = await apiClient.post("/getUnsutablePO_by_PONumber", {
  //       ponumber: poNumber,
  //       gatepassnumber: gatepassNumberFromList,
  //     });


  //     if (response.data[0].unsuitabilitytype === "Suitable") {
  //       setSuitabilityDone("Suitable")
  //     } 
  //     setunsuitablePOList(response.data);
  //     setButtonLoading(false);
  //   } catch (err) {
  //     setButtonLoading(false);
  //   }
    
  // }, [poNumber]); // Include indentNo in the dependency array if getPOdata depends on it

 const getUnsutablePOdata = useCallback(async () => {
  if (!poNumber || poNumber.trim() === "") return;
  if (!gatepassNumberFromList || gatepassNumberFromList.trim() === "") return;

  setButtonLoading(true);

  try {
    const response = await apiClient.post(
      "/getUnsutablePO_by_PONumber",
      {
        ponumber: poNumber,
        gatepassnumber: gatepassNumberFromList,
      }
    );

    if (response.data?.[0]?.unsuitabilitytype === "Suitable") {
      setSuitabilityDone("Suitable");
    }

    setunsuitablePOList(response.data || []);
  } catch (err) {
    // 🔥 ONLY THIS PART IS NEW
    if (err.response?.status === 425) {
      setunsuitablePOList([]);
      return;
    }

    console.error(err);
  } finally {
    setButtonLoading(false);
  }
}, [poNumber, gatepassNumberFromList]);



  const InsertPOData = async (e) => {
    //e.preventDefault();
    setButtonLoading(true);
    let formErrors = {};
    //if (dateerror) formErrors.errDate = "Invalid Suitability Date";
    // if (memodateerror) formErrors.memoerrDate = "Invalid Memo Date";

    if (!memoDate) {
      formErrors.errMemoDate = "Invalid Memo Date";
    }

    if (!suitabilityDate) {
      formErrors.errDate = "Invalid Suitability Date";
    }

    let SelectionTypeValue = "0";

    if (parseFloat(receivedQuantity) < parseFloat(suitableQty))
      formErrors.qty = "Qty should be less or equel then received Qty";

    if (!suitableQty || parseFloat(suitableQty) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (selectedOption === "1") {
      if (reason.length === 0) formErrors.err = "Remark Should not be Blank";
      SelectionTypeValue = rejectReason;
    }

    if (selectedOption === "0") {
      SelectionTypeValue = "0";
      setReason(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Suitable Type Not Selected";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const podt = new Date(suitabilityDate);
      const indentreceiptdt =
        podt.getFullYear() +
        "/" +
        parseInt(podt.getMonth() + 1) +
        "/" +
        podt.getDate();

      const memodt = new Date(memoDate);
      const memoreceiptdate =
        memodt.getFullYear() +
        "/" +
        parseInt(memodt.getMonth() + 1) +
        "/" +
        memodt.getDate();

      // console.log(poNumber);
      // console.log(suitableQty);
      // console.log(poQuantity);
      // console.log(indentreceiptdt);
      // console.log(memoreceiptdate);
      // console.log(SelectionTypeValue);
      // console.log(reason);
      // console.log(uname);
      // console.log(gatepassNumberFromList);
      // console.log(ip);

      apiClient
        .post("/sutabilityEntry", {
          vpoNumber: poNumber,
          vreceivedItemQty: suitableQty,
          vSuitabilityQty: poQuantity,
          vSuitabilityDate: indentreceiptdt,
          vMemoDate: memoreceiptdate,
          vsuitabilitystatus: SelectionTypeValue,
          vreason: reason + "",
          ventryUser: uname,
          vpassnumber: gatepassNumberFromList + "",
          vip: ip,
        })
        .then(function (response) {
          setError(response.data);
          getUnsutablePOdata();
          if (selectedOption === "0") {
            navigate("../suitabilitylist", { replace: true });
            
          }
          setButtonLoading(false);
          //
        })
        .catch(function (error) {
          // setsrcData([]);
          setError(error);
          setButtonLoading(false);
        });
       
    }
  };













const getdata = useCallback(async () => {
  if (!poNumberFromList?.trim()) return;
  if (!gatepassNumberFromList?.trim()) return;

  setButtonLoading(true);

  try {
    const response = await apiClient.post("/podetailssuitability", {
      uname,
      indentNumber: String(poNumberFromList),
      gatepassnumber: String(gatepassNumberFromList),
    });

    const data = response.data[0];

    setpoDate(data.PODate);
    setConsigneeName(data.POConsignee);
    setpoItemName(data.POItemName);
    setBalanceqty(data.balanceQty);
    setitemreceivedDate(data.itemReceivedDate);
    setreceivedQuantity(data.receivedItemQty);
    setreceivedvalue(data.receivedItemValue);
    setpoQuantity(data.receivedItemQty);
    setpoNumber(poNumberFromList);
    setSuitableQuantity(data.balanceQty);
  } catch (error) {
    setError(error);
  } finally {
    setButtonLoading(false);
  }
}, [uname, poNumberFromList, gatepassNumberFromList]);





  // const getdata = useCallback(

  //       async (e) => {

  //     if (!poNumberFromList || poNumberFromList.trim() === "") return;
  //     if (!gatepassNumberFromList || gatepassNumberFromList.trim() === "") return;
  //     setButtonLoading(true);
  //     try {
  //       const response = await apiClient.post("/podetailssuitability", {
  //         uname: uname,
  //         indentNumber: String(poNumberFromList),
  //         gatepassnumber: String(gatepassNumberFromList),
  //       });

  //       const data = response.data[0];

  //       setpoDate(data.PODate);
  //       setConsigneeName(data.POConsignee);
  //       setpoItemName(data.POItemName);

  //       setBalanceqty(data.balanceQty);

  //       setitemreceivedDate(data.itemReceivedDate);
  //       setreceivedQuantity(data.receivedItemQty);
  //       setreceivedvalue(data.receivedItemValue);

  //       // const minValueDate =
  //       // "'" + dayjs(response.data[0].ItemReceivedDate).format("YYYY-MM-DD") + "'";
  //       // setMinCalDate(dayjs(minValueDate));
  //       setpoQuantity(data.receivedItemQty);
  //       setpoNumber(poNumberFromList);
  //       setSuitableQuantity(data.balanceQty);
  //     } catch (error) {
  //       setError(error);
  //     }
  //     // console.log(minCalDate);
  //     setButtonLoading(false);
  //   },
  //   [uname]
  // );

//   useEffect(() => {
//     setButtonLoading(true);
//     getdata();
//     getUnsutablePOdata();
//     setButtonLoading(false);
//   }, [getdata, getUnsutablePOdata]);

// useEffect(() => {
//     setButtonLoading(true);
//     // Update state if roles change (in case roles are updated dynamically)
//     getUnsutablePOdata();
//     setButtonLoading(false);
//   }, [poNumber]);

// 1️⃣ Load PO base details ONCE
useEffect(() => {
  getdata();
}, [getdata]);


// 2️⃣ Load unsuitable list ONLY when poNumber is ready
useEffect(() => {
  if (poNumber) {
    getUnsutablePOdata();
  }
}, [poNumber, getUnsutablePOdata]);



  const headers = [
    //["Indent Number","",""],
    ["PO Number", "PO date", "Gate Pass/Memo"],
    ["Item Name", "Consignee", "Received Value"],
    [
      "Material Received Date",
      "Material Received Quantity",
      "Balance Suitable Qty",
    ],
  ];

  const rows = [
    [poNumber, poDate, gatepassNumberFromList],
    [poItemName, ConsigneeName, receivedvalue],
    [item_receivedDate, receivedQuantity, balanceqty],
  ];

  const suitabilitymenuoptions = [
    { value: "0", label: " Item Suitable" },
    { value: "1", label: " Item Not Suitable" },
  ];

  const columns = [
    "unsuitabilitytype",
    "SuitabilityDate",
    "reason",
    "receivedItemQty",
  ];

  const columnNames = [
    "Inspection Remark",
    "Suitability/Unsuitability Date",
    "Reason",
    "Quantity",
  ]; // keys from your data objects

  ////// canclelation  tools
  const [showcancleRemark, setShowcancleRemark] = useState(false);
  const [cancleRemark, setcancleRemark] = useState("");

  const poCancelConfirm = async () => {
    
    const isConfirmed = window.confirm(
      `Are you sure to Return PO Number: ${poNumber}`
    );
    if (isConfirmed) {
      setShowcancleRemark(true);
    } else {
      setShowcancleRemark(false);
      setcancleRemark("");
    }
  };

  const poReturn = async () => {
    const isConfirmed = window.confirm(
      `Are you sure to Return PO Number: ${poNumber}`
    );
    if (isConfirmed) {
      setPageLoader(true);
      try {
        //vpoNumber, vpassnumber, vreason, ventryUser, vip
        const response = await apiClient.post("/poreturn", {
          vponumber: poNumberFromList,
          vpassnumber: gatepassNumberFromList,
          ventryUser: uname,
          vip: ip,
          vreason: cancleRemark,
        });
        navigate("../suitabilitylist", { replace: true });
        setPageLoader(false);
        // navigate('../', { replace: true });
      } catch (error) {
        //alert(error);
        // navigate('../', { replace: true });
        navigate("../suitabilitylist", { replace: true });
        setPageLoader(false);
      }
    } else {
      setShowcancleRemark(false);
      setcancleRemark("");
      setPageLoader(false);
    }
  };
  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };
  return (
    <div>
      <Card className="Formcard">
        <div className="input-groupHeading">Suitability Details Entry</div>

        <CardContent>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ArrowDownwardIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span" variant="h6">
                PO Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ListHeaderTableComponent headers={headers} rows={rows} />
            </AccordionDetails>
          </Accordion>

          <div className="row mt-4">
            <div className="container">
              <div className="input-group">
                <CustomDropdownMenu
                  options={suitabilitymenuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={errors.selerr}
                  menulabel="Select Suitability Option"
                />
              </div>

              <div className="input-group">
                <NumericTextField
                  id="receivedItemQuantity"
                  label="Suitable Item Quantity"
                  title="Suitable Item Quantity"
                  error={errors.qty}
                  value={suitableQty ?? "0"}
                  onChange={handleQuantityChange}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="Memo Receipt Date"
                  id="MemoReceiptDate"
                  value={memoDate}
                  //onChange={setmemoDate}

                  onChange={(newDate) => handleDateChange(newDate, setmemoDate)}
                  error={errors.errMemoDate}
                  maxDate={today}
                  // minDate={item_receivedDate?dayjs(item_receivedDate):dayjs()}
                  minDate={poDate ? dayjs(poDate) : dayjs()}
                />
              </div>

              <div className="input-group">
                <DatePickerComponent
                  label="Suitability Date"
                  id="suitabilitydate"
                  value={suitabilityDate}
                  //onChange={setsuitabilityDate}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setsuitabilityDate)
                  }
                  error={errors.errDate}
                  maxDate={today}
                  // minDate={item_receivedDate?dayjs(item_receivedDate):dayjs()}
                  minDate={poDate ? dayjs(poDate) : dayjs()}
                />
              </div>
            </div>

            {/* here */}

            {!showRemark && (
              <>
                <div className="container">
                  <div className="input-group">
                    <DropdownfromDatabaseList
                      Options={rejectReasons}
                      option={rejectReason}
                      setOptionValue={setRejectReason}
                      DisplayItem1="reason"
                      DisplayItem2="id"
                    />
                  </div>

                  <div className="input-group">
                    <CustomTextField
                      label="Reason Why Rejected ---> it should be not blank if Suitability not OK "
                      value={reason ?? ""}
                      onChange={(e) => {
                        setReason(e.target.value);
                      }}
                      placeholder="Reason"
                      maxLength={100} // Set the maximum length
                      error={!!errors.err}
                      helperText={errors.err}
                    />
                  </div>
                </div>
              </>
            )}
          
          {/* ============================================LIST of ALL PO ===========================================*/}

          {unsuitablePOList.length > 0 && (
            <TablewithSumFooter
              columns={columns}
              columnNames={columnNames}
              data={unsuitablePOList}
            />
          )}
</div>
          {/*=========================== END OF LIST ==========================================================*/}

          <>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertPOData}
                title="Click for Data Save"
                disabled={buttonLoading}
              >
                Save Data
              </button>
              {(unsuitablePOList.length > 0) &&  (suitabilityDone !== "Suitable") &&  (
                <button
                  className="button button1"
                  type="button" // Updated type attribute to "button"
                  onClick={poCancelConfirm}
                  title="Click for Return to Consignee"
                  style={{ backgroundColor: "red", color: "white" }}
                >
                  Return to Consignee
                </button>
              )}
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "navy", color: "white" }}
              >
                Close
              </button>
              {showcancleRemark && (
                <>
                  <div className="container" style={{ marginTop: 60 }}>
                    <div className="input-group">
                      <CustomTextField
                        label="Remark --> it should be not blank"
                        value={cancleRemark ?? ""}
                        onChange={(e) => {
                          setcancleRemark(e.target.value);
                        }}
                        placeholder="Cancellation Reason"
                        maxLength={50} // Set the maximum length
                        error={!!errors.err}
                        helperText={errors.err}
                      />
                      <div
                        className="input-group"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                         {pageLoader ? (
                            <div className="loaderContainer">
                              <CircularProgress />
                            </div>
                          ) : (
                        <button
                          className="button button1"
                          type="button" // Updated type attribute to "button"
                          onClick={poReturn}
                          title="Click for Return PO"
                          style={{ backgroundColor: "black", color: "white" }}
                        >
                          Click here: Finally Return
                        </button>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              )}
              ;
            </div>
          </>
        </CardContent>
      </Card>
    </div>
  );
}

export default SuitabilityEntry;
